import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:3300",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aiboek_token");
  const companyId = localStorage.getItem("aiboek_company_id");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (companyId) {
    config.headers["X-Company-Id"] = companyId;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("aiboek_token");
      localStorage.removeItem("aiboek_company_id");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;